import { basics } from "../../basics";
import cafeBaza from "../../resources/images/app/cafe-bazar.png";
import shopLogo from "../../resources/images/app/ic_icon.png";
const GetApplications = () => {
  return (
    <div className="flex flex-col justify-center items-center gap-3">
      <div className="flex flex-col justify-center items-center">
        <div className="flex justify-center items-start">
          <div>
            <img src={shopLogo} alt="" className="h-16" />
          </div>
          <div className="flex flex-col justify-center items-start">
            <h3 className=" text-sm  m-1">{basics.getApplicationTitle}</h3>
            <h2 className="font-bold text-lg m-1">
              {basics.getApplicationDesc}
            </h2>
          </div>
        </div>
        <div className="m-2">
          <a href="https://cafebazaar.ir/app/co.market.Mivekani.Mivekani">
            <img
              src={cafeBaza}
              alt="دریافت اپلیکیشن از کافه بازار"
              className=""
            />
          </a>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 justify-start items-start py-3">
        <div className="h-[100px] w-[100px] flex items-center justify-center ">
          <a
            referrerPolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=631066&Code=ceQ7M7eGFNi3RKIhMNOIagYy5pGzhtHV"
          >
            <img
              referrerPolicy="origin"
              src="https://trustseal.enamad.ir/logo.aspx?id=631066&Code=ceQ7M7eGFNi3RKIhMNOIagYy5pGzhtHV"
              alt="نماد اعتماد الکترونیکی"
              //  style={'cursor:pointer'}
              id="ceQ7M7eGFNi3RKIhMNOIagYy5pGzhtHV"
            />
          </a>
        </div>
        <div className="h-[100px] w-[100px] flex items-center justify-center">
          <a
            referrerPolicy="origin"
            target="_blank"
            href="https://www.ecunion.ir/verify/mivekani.com?token=415625868e9e784ef62f"
            rel="noopener noreferrer"
          >
            <img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+ "
              alt="عضو اتحادیه کشوری کسب و کارهای مجازی"
              onClick={() =>
                window.open(
                  "https://www.ecunion.ir/verify/mivekani.com?token=415625868e9e784ef62f",
                  "Popup",
                  "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30"
                )
              }
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default GetApplications;
